const formatUnit = (unit: 'byte' | 'kilobyte' | 'megabyte') =>
  new Intl.NumberFormat(undefined, {
    style: 'unit',
    unit,
    maximumFractionDigits: 1,
    unitDisplay: 'narrow',
  });

const BYTE_UNITS = [
  {divisor: 1, formatter: formatUnit('byte')},
  {divisor: 1024, formatter: formatUnit('kilobyte')},
  {divisor: 1024 * 1024, formatter: formatUnit('megabyte')},
] as const;

export const formatByteSize = (byteSize: number): string => {
  const match = BYTE_UNITS.findLast(({divisor}) => byteSize >= divisor) ?? BYTE_UNITS[0];
  return match.formatter.format(byteSize / match.divisor);
};
